import React from 'react';

const Logo = ({ 
  variant = 'color', // 'color', 'monochrome', 'icon'
  size = 'default', // 'sm', 'default', 'lg', 'xl'
  className = '',
  showText = true
}) => {
  const sizeClasses = {
    sm: 'h-10 w-10',
    default: 'h-12 w-12',
    lg: 'h-16 w-16',
    xl: 'h-20 w-20'
  };

  const textSizeClasses = {
    sm: 'text-xl',
    default: 'text-2xl',
    lg: 'text-3xl',
    xl: 'text-4xl'
  };

  const getLogoSrc = () => {
    switch (variant) {
      case 'monochrome':
        return '/logos/monochrome/pharma_chargeback_logo_bw.svg';
      case 'icon':
        return '/png/icon_128x128.png';
      case 'color':
      default:
        return '/png/icon_128x128.png';
    }
  };

  const getAltText = () => {
    switch (variant) {
      case 'monochrome':
        return 'PharmaChargeback Logo (Monochrome)';
      case 'icon':
        return 'PharmaChargeback Icon';
      case 'color':
      default:
        return 'PharmaChargeback Logo';
    }
  };

  if (variant === 'icon' || !showText) {
    return (
      <img
        src={getLogoSrc()}
        alt={getAltText()}
        className={`${sizeClasses[size]} ${className}`}
      />
    );
  }

  return (
    <div className={`flex items-center ${className}`}>
      <img
        src={getLogoSrc()}
        alt={getAltText()}
        className={`${sizeClasses[size]}`}
      />
      {showText && (
        <span className={`font-heading font-bold text-primary-600 ${textSizeClasses[size]} ml-2 brand`}>
          PC
        </span>
      )}
    </div>
  );
};

export default Logo;
